<template v-if="isOwnershipEvent()">
  <span>
    {{ addedText() }}
    <template v-for="(userId, i) in addedUserIds">
      <span class="bold" :key="'added' + i"
        ><user-short :show-user-name="true" :user-id="userId" :show-avatar="false"/></span
      >{{ wordSeperator(i, addedUserIds) }}
    </template>
    <template v-if="isNotEmpty(addedUserIds) && isNotEmpty(removedUserIds)"
      >and
    </template>
    {{ removedText() }}
    <template v-for="(userId, i) in removedUserIds">
      <span class="bold" :key="'removed-' + i"
        ><user-short :show-user-name="true" :user-id="userId" :show-avatar="false"/></span
      >{{ wordSeperator(i, removedUserIds) }}
    </template>
    as an owner
  </span>
</template>
<script>
import { INITIATIVE_EVENT_TYPE } from '@/constants/initiative'
import { GOAL_EVENT_TYPE } from '@/constants/goal'
import UserShort from '@/components/UserShort'
/**
 * This shows the ownership change message on events page for goal/kr/initiative.
 */
export default {
  name: 'OwnershipChangeEvent',
  props: ['event'],
  data() {
    return {
      ownershipChangeEvents: [INITIATIVE_EVENT_TYPE, GOAL_EVENT_TYPE],
      addedUserIds: [],
      removedUserIds: []
    }
  },
  computed: {},
  components: {
    UserShort
  },
  methods: {
    isOwnershipEvent() {
      const changes = this.event.changes
      return (
        this.event &&
        this.ownershipChangeEvents.includes(this.event.type) &&
        changes &&
        (this.isNotEmpty(changes.addedUserIds) || this.isNotEmpty(changes.removedUserIds))
      )
    },
    isNotEmpty(arr) {
      return arr && arr.length > 0
    },
    addedText() {
      return this.isNotEmpty(this.addedUserIds) ? ' added' : ''
    },
    removedText() {
      return this.isNotEmpty(this.removedUserIds) ? ' removed' : ''
    },
    wordSeperator(index, userIds) {
      const len = userIds.length
      if (len <= 1 || index == len - 1) {
        return ''
      } else if (index == len - 2) {
        return ' and'
      } else {
        return ','
      }
    }
  },
  mounted() {
    this.addedUserIds =
      this.event && this.event.changes && this.event.changes.addedUserIds
        ? this.event.changes.addedUserIds
        : []
    this.removedUserIds =
      this.event && this.event.changes && this.event.changes.removedUserIds
        ? this.event.changes.removedUserIds
        : []
  }
}
</script>
